module.exports = __webpack_public_path__ + "media/images/area/maps/tohoku-4fcdaa770f9d5faa22eb72dc1b49e21e.svg";